import React, { useEffect, useContext, useState } from 'react';
import styled from 'styled-components/macro';
import {PropSheet, PropSheetTitle, TextField, SelectField, TextAreaField, CheckboxField, OptionSelect} from './UI';
import EditorContext from '../../modules/contexts/editor';
import { updateNodeType } from '../../modules/libs/lessonLib';
import { styleChoices, backgroundChoices } from '../../modules/defines/style';

// properties
//    name:          	String,	// section name
//    type:      	String,	// section type (block, conditional, aside, etc.)
//    modes:    		List(String),	// The modes with which this section is associated
//    spec:    		Dict,		// additional specs for controlling display, sequencing, etc.

const SectionPropSheet = ({ node }) => {
    const editor = useContext(EditorContext);

    const onBlur = (field, value) => {
        editor.updateNodeField(node, field, value);
        editor.commitNodeUpdate(node);
    };

    return (
        <PropSheet>
            <PropSheetTitle>Section ({node.nodeID})</PropSheetTitle>
            <TextField label='Title' inputRef={input => { if (input) input.value = node.title; }} onBlur={e => onBlur('title', e.target.value)} />
            <CheckboxField label="Don't include in Section Navigator" checked={Boolean(node.notInSectionNav)} onChange={e => onBlur('notInSectionNav', e.target.checked)} />
            <CheckboxField label="Mini-lesson" checked={Boolean(node.miniLesson)} onChange={e => onBlur('miniLesson', e.target.checked)} />
            <OptionSelect node={node} field={{label: 'Background', value: node.background || 'Default', choices: backgroundChoices(node)}} onSelect={e => onBlur('background', e.target.value)} />
            { styleChoices(node) && (
                <OptionSelect node={node} field={{label: 'Style', value: node.style || 'Normal', choices: styleChoices(node)}} onSelect={e => onBlur('style', e.target.value)} />
            )}
        </PropSheet>
    );
};

export default SectionPropSheet;
